<script>
  import { vehicles } from '../../store/vehicles.js'
  import { strings } from '../../store/store'

  export let chosenVehicleType,
    chosenEnvClass,
    distance,
    fuelPrice,
    load,
    fuelConsumption,
    getCalculatedEmissions

  const handleSelectVehicle = () => {
    const [currentEnvClass] = chosenVehicleType.environmentalClass.filter(
      (envClass) => envClass.class === chosenEnvClass.class
    )
    chosenEnvClass = currentEnvClass
      ? currentEnvClass
      : chosenVehicleType.environmentalClass[0]
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    getCalculatedEmissions()
  }

  const getVehicleTitle = (vehicle) => {
    let vehicleTitle

    switch (vehicle.vehicleType) {
      case 1:
        vehicleTitle = $strings.vehicleTitleType1
        break
      case 2:
        vehicleTitle = $strings.vehicleTitleType2
        break
      case 3:
        vehicleTitle = $strings.vehicleTitleType3
        break
      case 4:
        vehicleTitle = $strings.vehicleTitleType4
        break

      default:
        break
    }
    return vehicleTitle ? vehicleTitle : vehicle.vehicleTitle
  }
</script>

<form on:submit={handleSubmit}>
  <h4>{$strings.calculatorHeading}</h4>
  <div class="input-field">
    <label for="vehicleType" class="required"
      >{$strings.vehicleTypeSelectLabel}</label
    >
    <select
      name="vehicleType"
      bind:value={chosenVehicleType}
      on:change={handleSelectVehicle}
      required
    >
      {#each vehicles as vehicle}
        <option value={vehicle}>{getVehicleTitle(vehicle)}</option>
      {/each}
    </select>
    <span class="dropdown-arrow">
      <div class="left-line" />
      <div class="right-line" />
    </span>
  </div>

  <div class="input-field">
    <label for="envClass" class="required">{$strings.envClassSelectLabel}</label
    >
    <select name="envClass" bind:value={chosenEnvClass}>
      {#each chosenVehicleType.environmentalClass as envClass}
        <option value={envClass}>{envClass.class}</option>
      {/each}
    </select>
    <span class="dropdown-arrow">
      <div class="left-line" />
      <div class="right-line" />
    </span>
  </div>

  <div class="input-field">
    <label for="distance" class="required"
      >{$strings.transportDistanceInputLabel}</label
    >
    <input
      type="number"
      name="distance"
      bind:value={distance}
      step="any"
      required
    />
    <span>km</span>
  </div>

  <div class="input-field">
    <label for="fuelPrice" class="required"
      >{$strings.fuelPriceInputLabel}</label
    >
    <input
      type="number"
      name="fuelPrice"
      bind:value={fuelPrice}
      step="any"
      required
    />
    <span>eur/l</span>
  </div>

  <h4>{$strings.direction1Text}</h4>
  <div class="input-field">
    <label for="load1" class="required">{$strings.loadInputLabel}</label>
    <input
      type="number"
      name="load1"
      bind:value={load.direction1}
      step="any"
      required
    />
    <span>t</span>
  </div>

  <div class="input-field">
    <label for="fuelConsumption1">{$strings.fuelConsumptionInputLabel}</label>
    <input
      type="number"
      name="fuelConsumption1"
      bind:value={fuelConsumption.direction1}
      step="any"
    />
    <span>l/100 km</span>
  </div>

  <h4>{$strings.direction2Text}</h4>

  <div class="input-field">
    <label for="load2" class="required">{$strings.loadInputLabel}</label>
    <input
      type="number"
      name="load2"
      bind:value={load.direction2}
      step="any"
      required
    />
    <span>t</span>
  </div>

  <div class="input-field">
    <label for="fuelConsumption2">{$strings.fuelConsumptionInputLabel}</label>
    <input
      type="number"
      name="fuelConsumption2"
      bind:value={fuelConsumption.direction2}
      step="any"
    />
    <span>l/100 km</span>
  </div>

  <button>
    {$strings.calculatorSubmitButtonText}
    <svg class="arrow" width="57" height="19" fill="none">
      <path
        d="M45.8 0c.1 2.8 1 6.8 2.8 9.1L.5 8.6v1l48 .5c-1.9 2.4-2.6 6.1-2.8 9.1 3-3.9 6.6-7.7 11.1-9.6-4.4-2-8.2-5.5-11-9.6z"
        fill="#fff"
      />
    </svg>
  </button>
</form>

<style>
  form {
    display: flex;
    flex-direction: column;
    background-color: #efe2ab;
    padding: 28px;
  }
  input,
  select {
    width: 100%;
    height: 38px;
    border: none;
    border-bottom: 2px solid black;
    padding: 9px 26px 9px 12px;
    font-size: 14px;
    background-color: white;
    margin-bottom: 10px;
  }

  select {
    cursor: pointer;
  }

  select,
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    appearance: none;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  input:focus,
  select:focus {
    outline: none;
    border: 2px solid black;
  }

  label {
    font-size: 14px;
  }

  .required::after {
    content: '*';
    vertical-align: top;
  }
  h4:first-child {
    margin-top: 0;
  }
  button {
    background-color: #18173c;
    color: white;
    font-size: 14px;
    height: 44px;
    width: 184px;
    padding: 0 16px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: flex-end;
    border: none;
    margin-top: 18px;
  }

  button:hover {
    background-color: #0606cc;
    cursor: pointer;
  }

  .input-field {
    position: relative;
  }

  .input-field span {
    color: #8b8b8b;
    position: absolute;
    right: 12px;
    top: 30px;
    font-weight: 300;
    font-size: 14px;
  }

  .input-field .dropdown-arrow {
    display: flex;
    top: 37px;
    pointer-events: none;
  }

  .left-line,
  .right-line {
    width: 6px;
    height: 6px;
    border-bottom: 1.5px solid black;
    position: relative;
  }

  .left-line {
    transform: rotate(45deg);
    left: 6px;
  }

  .right-line {
    transform: rotate(-45deg);
  }
</style>
